import { render, staticRenderFns } from "./HtmlText.vue?vue&type=template&id=6deeb5b8&"
import script from "./HtmlText.vue?vue&type=script&lang=js&"
export * from "./HtmlText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports